import React, { useMemo } from 'react';
import { BOARD_FILTER_SCOPE } from './filterScopeUtils';

const OPTIONS = [
  { value: BOARD_FILTER_SCOPE.EM_ABERTO, label: 'Em aberto' },
  { value: BOARD_FILTER_SCOPE.TECNICOS, label: 'Técnicos' },
  { value: BOARD_FILTER_SCOPE.AMBOS, label: 'Ambos' },
];

export function BoardSearchFiltersScope({ value, onChange, disabledScopes = [] }) {
  const disabledSet = useMemo(() => new Set(disabledScopes), [disabledScopes]);

  return (
    <div
      className="bsf-scope-group"
      role="radiogroup"
      aria-label="Aplicar filtros em"
      data-tour="bsf-scope-group"
    >
      {OPTIONS.map((opt) => {
        const disabled = disabledSet.has(opt.value);
        return (
          <label
            key={opt.value}
            className={`bsf-scope-option${disabled ? ' is-disabled' : ''}`}
            data-tour={
              opt.value === BOARD_FILTER_SCOPE.EM_ABERTO
                ? 'bsf-scope-em-aberto'
                : opt.value === BOARD_FILTER_SCOPE.TECNICOS
                  ? 'bsf-scope-tecnicos'
                  : opt.value === BOARD_FILTER_SCOPE.AMBOS
                    ? 'bsf-scope-ambos'
                    : undefined
            }
          >
            <input
              type="radio"
              name="board-search-filter-scope"
              className="bsf-scope-radio"
              checked={value === opt.value}
              disabled={disabled}
              onChange={() => {
                if (!disabled) onChange(opt.value);
              }}
            />
            <span className="bsf-scope-label">{opt.label}</span>
          </label>
        );
      })}
    </div>
  );
}
